import React from 'react';

import LoginFormContainer from 'dpl/containers/LoginFormContainer';

export default function UserAuthLoginForm() {
  return (
    <div className="UserAuthLoginForm">
      <h1 className="mb10 f6">Log in to Good Dog</h1>

      <LoginFormContainer buttonClassName="w-100 button button--primary ph7 pv2 center" />
    </div>
  );
}
